import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ 
  icon, 
  label, 
  value, 
  unit = '', 
  change, 
  changeType = 'neutral',
  trend = 'up',
  color = 'var(--color-primary)'
}) => {
  const getTrendIcon = () => {
    if (changeType === 'neutral') return null;
    return trend === 'up' ? 'TrendingUp' : 'TrendingDown';
  };

  const getChangeColor = () => {
    if (changeType === 'positive') return 'text-success';
    if (changeType === 'negative') return 'text-error';
    return 'text-muted-foreground';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 shadow-md hover-lift transition-smooth">
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10">
          <Icon name={icon} size={20} color={color} strokeWidth={2.5} />
        </div>
        {change && (
          <div className={`flex items-center gap-1 ${getChangeColor()}`}>
            {getTrendIcon() && <Icon name={getTrendIcon()} size={16} />}
            <span className="text-xs md:text-sm font-semibold data-text">{change}</span>
          </div>
        )}
      </div>
      <div>
        <p className="text-xs md:text-sm caption text-muted-foreground mb-1">{label}</p>
        <div className="flex items-baseline gap-1">
          <span className="text-2xl md:text-3xl font-heading font-bold text-foreground data-text">
            {value}
          </span>
          {unit && (
            <span className="text-sm md:text-base text-muted-foreground">{unit}</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default MetricCard;